import React from 'react';

// Importing all sections used in the homepage
import { Home, About, Counter, Testimonials, Blogs, Services, WhyUs, NewsletterSection, Features, Team, ProjectSection, Partners, Banner, Destinations, Tours, Events, Activities, Pricing } from '../../sections';



const HomePage = () => {

  return (
    <div className='homepage'>
      <Home /> {/* Home Section */}
      <Features /> {/* Features Section */}
      <About /> {/* About Section */}
      <Counter /> {/* Counter Section */}
      <Services /> {/* Services Slider */}
      <ProjectSection /> {/* Project Section */}
      <WhyUs /> {/* Why Choose Us section */}
      <Destinations /> {/* Destination Section */}
      <Tours /> {/* Popular Tours Slider */}
      <Banner /> {/* Banner Section */}
      <Events /> {/* Top 2 Events Section */}
      <Activities /> {/* Activities Slider */}
      <Testimonials /> {/* Testimonials Slider */}
      <Team /> {/* Team section */}
      <Pricing /> {/* Pricing Section */}
      <NewsletterSection /> {/* Newsletter subscription Section */}
      <Blogs /> {/* Latest blog posts */}
      <Partners /> {/* Partners Slider */}
    </div>
  )

}

export default HomePage;